import 'arrive'
import Swiper, { Navigation, Pagination, Scrollbar, Keyboard } from 'swiper'
import $ from 'jquery'

Swiper.use([Navigation, Pagination, Scrollbar, Keyboard])

document.arrive('.slider', {existing: true}, function() {

  const slider = this;
  var $slider = $(this)

  const slidesInView = parseFloat(this.getAttribute('data-slides-inview'));
  const preventLoop = parseFloat(this.getAttribute('data-slider-prevent-loop'));
  const slidesCentered = parseInt(this.getAttribute('data-slides-center'));
  const slidesGap = parseInt(this.getAttribute('data-slides-gap'));
  const slidesMobile = parseFloat(this.getAttribute('data-slides-mobile'));

  let slidesTablet = slidesInView;
  const slidesGapMobile = Math.ceil(slidesGap * 0.66);

  if ( slidesInView >= 2 ) {
    slidesTablet = slidesInView - 1;
  }

  const initSlider = new Swiper(slider, {

    loop: !preventLoop,
    speed: 600,
    direction: 'horizontal',
    effect: 'slide',
    centeredSlides: slidesCentered,
    initialSlide: 1,
    keyboard: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: slidesInView,
    spaceBetween: slidesGap,
    allowTouchMove: true,
    pagination: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: false,

    scrollbar: {
      el: $slider.find('.swiper-scrollbar').get(0),
      draggable: true,
      hide: false,
    },
    breakpoints: {

      0: {
        centeredSlides: true,
        spaceBetween: slidesGapMobile,
        slidesPerView: slidesMobile,
      },

      768: {
        centeredSlides: true,
        spaceBetween: slidesGapMobile,
        slidesPerView: slidesTablet
      },

      992: {
        centeredSlides: true,
        spaceBetween: slidesGap,
        slidesPerView: slidesInView
      }

    },
  });

  let keyPressed = 0;

  $("body").on('keydown', function(e) {
    if (e.code === "ArrowLeft" || e.code === "ArrowRight") keyPressed = new Date().getTime();
  });

  initSlider.on('slideChange', function () {
    onSlideChange(this);
  });

  function onSlideChange(data){
    const trigger = data.slides[data.activeIndex].querySelector('.slide-trigger');
    if (new Date().getTime() - keyPressed < 10) {
      if (trigger) $(trigger).focus();
      else $(data.slides[data.activeIndex]).focus();
    }
  }
});


document.arrive('.slide-trigger', {existing: true}, function() {
  $(this).on('keydown', function(e) {
    if (e.type == 'keydown' && e.code !== 'Space' && e.code !== 'Enter') return;
    const href = this.getAttribute('href');
    if (href) {
        location.href = href;
    }
    e.preventDefault();
    e.stopPropagation();
  });
});
